export class Recruit {
  constructor(id, slug, title, content, status, category, description, location, holidays, overtime, benefits, salary, bonus, background) {
    this.id = id;
    this.slug = slug;
    this.title = title;
    this.content = content;
    this.status = status;
    this.category = category;
    this.description = description;
    this.location = location;
    this.holidays = holidays;
    this.overtime = overtime;
    this.benefits = benefits;
    this.salary = salary;
    this.bonus = bonus;
    this.background = background;
  }
  static fromWPJson(json) {
    const id = json.getOr(["databaseId"], null);
    const slug = json.getOr(["slug"], null);
    const title = json.getOr(["title"], null);
    const content = json.getOr(["content"], null);
    const status = json.getOr(["acf", "status"], null);
    const category = json.getOr(["acf", "category"], null);
    const description = json.getOr(["acf", "description"], null);
    const location = json.getOr(["acf", "location"], null);
    const holidays = json.getOr(["acf", "holidays"], null);
    const overtime = json.getOr(["acf", "overtime"], null);
    const benefits = json.getOr(["acf", "benefits"], null);
    const salary = json.getOr(["acf", "salary"], null);
    const bonus = json.getOr(["acf", "bonus"], null);
    const background = json.getOr(["acf", "background"], null);
    return new Recruit(id, slug, title, content, status, category, description, location, holidays, overtime, benefits, salary, bonus, background);
  }
}
//# sourceMappingURL=index.js.map
